interface DropdownProps {
  options: string[];
  label: string;
  onchange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
}

const Dropdown = ({
  options,
  label,
  onchange,
  value,
  onBlur,
}: DropdownProps): JSX.Element => (
  <>
    <label className="label">{label}</label>
    <div className="select">
      <select
        className="select"
        onChange={onchange}
        value={value}
        onBlur={onBlur}>
        <option value="">---</option>
        {options.map(option => (
          <option key={option}>{option}</option>
        ))}
      </select>
    </div>
  </>
);

Dropdown.defaultProps = {
  onBlur: () => {},
};

export default Dropdown;
